module.exports = __webpack_public_path__ + "static/flags/BA-10b5a803e757788250281b7f59e7fce5.gif";